import { service } from "@server/client";
import type {
  CreateCartMutation,
  CreateCartMutationVariables,
} from "@server/gql/graphql";
import { createCartMutation } from "@server/queries/cart";

export const createNewCart = async (variables: CreateCartMutationVariables) => {
  try {
    const response = await service<
      CreateCartMutation,
      CreateCartMutationVariables
    >({
      query: createCartMutation,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in createNewCart", error);
    throw error;
  }
};
